// PLA-860 v3 (W7, D4): fracciones y grupos de subdivisiones abiertos, recordados en el navegador
// por orden, corrida y etapa. Si el almacenamiento no esta disponible se usa el estado inicial.
export type FractionsStage = 'finalise' | 'qa';

const KEY_PREFIX = 'atlas.fractions.expanded';

export const expansionStorageKey = (
  millingOrderId: number,
  fractionVersionId: number,
  stage: FractionsStage
): string => `${KEY_PREFIX}.${millingOrderId}.${fractionVersionId}.${stage}`;

// Las ids se guardan como texto: JSON:API las entrega como string.
export const loadExpandedIds = (key: string): string[] | null => {
  try {
    const value = window.localStorage.getItem(key);

    if (value === null) {
      return null;
    }

    const ids = JSON.parse(value);

    return Array.isArray(ids) ? ids.map(String) : null;
  } catch (_error) {
    return null;
  }
};

export const saveExpandedIds = (key: string, ids: string[]): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(ids));
  } catch (_error) {
    // Almacenamiento bloqueado o lleno: el estado se mantiene solo en memoria.
  }
};
